<template>
  <v-layout fill-height column>
    <v-container fill-flex>
      <div class="question mt-9 mb-14" v-html="question"></div>
      <div class="emotion-text mb-18">
          <span v-for="item in emotionStrArr.length" :key="item" :style="{'color':emotionStrArr[item-1].color}">
              {{emotionStrArr[item-1].cdNm}}
          </span>
      </div>
      <Textarea
          :value="value"
          :height="200"
          :counter="500"
          :placeholder="`최대한 자세히 작성해보세요.`"
          @input="inputChanged"
      />
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="$emit('next')" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props:{
    current:Number,
    total:Number,
  },
  data: ()=> ({
    value: '',
    question:"2.질문(어드민에서 등록,<br>선택 사항0~최대5개,페이지별로 질문1개)?",
    emotionStrArr: [
        {title:'행복한',color:'#FFCA19',value:'행복한'},
        {title:'화난',color:'#FF6019',value:'억울한'},
        {title:'우울한',color:'#000',value:'마음이 무거운'},
    ],
  }),
  components:{
    Textarea,
    FooterBtnsNext
  },
  methods:{
   inputChanged(input){
     this.value = input;
   },
  }
}
</script>
